<ng-container *transloco="let t">
  <footer class="flex flex-col max-sm:w-full" id="login-footer">
    @if (!isMobile()) {
      <div
        class="login-footer__support flex items-center w-full gap-10 px-8 py-4 max-md:flex-col max-md:items-center max-md:gap-4 max-md:px-4 max-md:pb-6"
        [style.background]="supportBgColor()"
        id="login-footer-support"
      >
        <div
          class="flex flex-col flex-1 min-w-0 max-md:flex-none max-md:w-full max-md:text-center"
          id="login-footer-support-heading"
        >
          <span class="font-dm text-xl font-semibold leading-6 text-[#222222]">
            {{ t('loginFooterGotQuestions') }}
          </span>
          <span class="font-dm text-sm font-normal leading-5 text-[#222222]">
            {{ t('loginFooterContactSupportCenter') }}
          </span>
        </div>

        <div class="contents max-md:flex max-md:gap-6 max-md:justify-center" id="login-footer-contact-links">
          <a
            [href]="supportPhoneTel"
            class="flex items-center gap-3 flex-1 min-w-0 text-[#222222] no-underline hover:underline focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 focus-visible:rounded-sm max-md:flex-none"
            id="login-footer-phone-link"
          >
            <ld-svg-icon [src]="phoneIconSrc" class="w-5 h-5 shrink-0" aria-hidden="true" />
            <span class="font-dm text-sm font-normal leading-5">{{ supportPhoneDisplay }}</span>
          </a>

          <a
            [href]="customerCareEmailMailto"
            class="flex items-center gap-3 flex-1 min-w-0 text-[#222222] no-underline hover:underline focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 focus-visible:rounded-sm max-md:flex-none"
            id="login-footer-email-link"
          >
            <ld-svg-icon [src]="envelopeIconSrc" class="w-5 h-5 shrink-0" aria-hidden="true" />
            <span class="font-dm text-sm font-normal leading-5">{{ t('loginFooterCustomerCare') }}</span>
          </a>
        </div>

        <div class="shrink-0 max-md:flex-none" id="login-footer-share-screen-wrapper">
          <button
            type="button"
            class="login-footer__share-btn flex items-center gap-3 rounded-[20px] px-6 py-2.5 font-dm text-sm font-medium leading-5 text-[#222222] cursor-pointer border-0 hover:brightness-95 focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 focus-visible:rounded-[20px]"
            id="login-footer-share-screen-btn"
            [disabled]="isShareScreenLoading()"
            [class.opacity-60]="isShareScreenLoading()"
            [class.pointer-events-none]="isShareScreenLoading()"
            (click)="onShareScreenClick()"
          >
            @if (isShareScreenLoading()) {
              <mat-spinner diameter="16" class="inline-block" />
            } @else {
              <ld-svg-icon [src]="shareScreenIconSrc" class="w-4 h-4 [--stroke-0:#222222]" aria-hidden="true" />
            }
            {{ t('loginFooterShareMyScreen') }}
          </button>
        </div>
      </div>
    } @else {
      <div
        class="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 w-full bg-[#f4f4f6] px-4 py-4 pb-[calc(1rem+env(safe-area-inset-bottom,0px))]"
        id="login-footer-mobile"
      >
        <a
          [href]="supportPhoneTel"
          class="flex items-center gap-2 text-[#222222] no-underline hover:underline focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 focus-visible:rounded-sm"
          id="login-footer-phone-link-mobile"
        >
          <ld-svg-icon [src]="phoneIconSrc" class="w-4 h-4 shrink-0" aria-hidden="true" />
          <span class="font-dm text-[12px] font-normal leading-4">{{ supportPhoneDisplay }}</span>
        </a>

        <a
          [href]="customerCareEmailMailto"
          class="flex items-center gap-2 text-[#222222] no-underline hover:underline focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 focus-visible:rounded-sm"
          id="login-footer-email-link-mobile"
        >
          <ld-svg-icon [src]="envelopeIconSrc" class="w-4 h-4 shrink-0" aria-hidden="true" />
          <span class="font-dm text-[12px] font-normal leading-4">{{ t('loginFooterCustomerCare') }}</span>
        </a>

        <button
          type="button"
          class="flex items-center gap-2 bg-transparent border-0 p-0 font-dm text-[12px] font-normal leading-4 text-[#5b2d8e] cursor-pointer no-underline hover:underline focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 focus-visible:rounded-sm"
          id="login-footer-share-screen-btn-mobile"
          [disabled]="isShareScreenLoading()"
          [class.opacity-60]="isShareScreenLoading()"
          [class.pointer-events-none]="isShareScreenLoading()"
          (click)="onShareScreenClick()"
        >
          @if (isShareScreenLoading()) {
            <mat-spinner diameter="14" class="inline-block" />
          } @else {
            <ld-svg-icon [src]="shareScreenIconSrc" class="w-4 h-4" aria-hidden="true" />
          }
          {{ t('loginFooterShareMyScreen') }}
        </button>
      </div>
    }
  </footer>
</ng-container>
